<template lang="pug">
	div
		md-dialog-content
			h4: b Order Info

			invoice-detail(:products="order.items",
			:subtotal="subtotal",
			:taxAmount="taxAmount",
			:total="total")

			p
				h4: b Customer information

			contacts-block(:contacts="contacts")

			h4: b Payment Method

			credit-card(:card="card")

			hr
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
	name: 'ag-grid-order-detail-popup',
	props: ['orderProp', 'orderDProp', 'contactsProp', 'cardProp'],
	data () {
		return {
			showOrderDetail: false,
			order: null,
			card: null,
			contacts: [],
			orderDate: '',
			project: null
		}
	},
	created () {
		this.order = this.orderProp
		this.orderDate = this.orderDProp
		this.contacts = this.contactsProp
		this.card = this.cardProp
	},
	methods: {
		openOrder () {
		}
	},
	computed: {
		subtotal () {
			return (Math.round(this.order.orderSubtotal * 100) / 100).toFixed(2)
		},
		taxAmount () {
			return (Math.round(this.order.orderTax * 100) / 100).toFixed(2)
		},
		total () {
			const tot = parseFloat(this.order.orderTax) + parseFloat(this.order.orderSubtotal)
			return (Math.round(tot * 100) / 100).toFixed(2)
		}
	}
})
</script>



// WEBPACK FOOTER //
// src/app/project/ag-grid/preview-order-component.vue